module.exports = __webpack_public_path__ + "static/grapecity-webinars.2e322c92.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/grapecity-webinars.webp
// module id = 443
// module chunks = 23899280101116